module.exports = __webpack_public_path__ + "img/热销商品5.5d2f96a9.png";